const state = {
    formChanged: false,
}

const getters = {

    formChanged: state => {
        return state.formChanged;
    },

}

const mutations = {

    setFormChanged(state, formChanged) {
        state.formChanged = formChanged;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}